// MUI
import { Stack } from "@mui/material";

// Components
import NavButton from "@DataPages/components/Inventory/Layout/NavButton";

// Types
type DialogNavigationProps = {
	onPrev: () => void;
	onNext: () => void;
	className?: string;
	disabledButtons?: {
		prev: boolean;
		next: boolean;
	};
};

export default function DialogNavigation(props: Readonly<DialogNavigationProps>) {
	return (
		<Stack direction={"row"} className={props.className} justifyContent={"center"} spacing={"30px"}>
			<NavButton direction={"prev"} onClick={props.onPrev} disabled={props.disabledButtons?.prev} />
			<NavButton direction={"next"} onClick={props.onNext} disabled={props.disabledButtons?.next} />
		</Stack>
	);
}
